export const EVENTS_ENUM = {
  NEW_BONUS: 'new_bonus',
  FS_BONUS_ACTIVATE: 'fs_bonus_activated',
  LIMIT_EXCEEDED: 'limit_exceeded',
  PAUSE_LIMIT_EXCEEDED: 'pause_limit_exceeded',
  USER_UPDATED: 'user_updated',
}
